import { render, staticRenderFns } from "./CustomersHeader.vue?vue&type=template&id=869fb3ca&scoped=true&"
import script from "./CustomersHeader.vue?vue&type=script&lang=ts&"
export * from "./CustomersHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CustomersHeader.vue?vue&type=style&index=0&id=869fb3ca&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869fb3ca",
  null
  
)

export default component.exports